import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import * as styles from './AdDetails.scss';
import pluralize from 'pluralize';
import { StackedBigText } from 'components';

var humanFormat = require('human-format');

var numberFormatScale = new humanFormat.Scale({
  '': 1,
  k: 1000,
  M: 1000000,
  B: 1000000000,
  T: 1000000000000
});
var OverviewStats = (_dec = connect(function (state, ownProps) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(OverviewStats, _Component);

  var _super = _createSuper(OverviewStats);

  function OverviewStats(props) {
    var _this;

    _classCallCheck(this, OverviewStats);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatNumber", function (num) {
      if (num > 9999) {
        return humanFormat(num, {
          scale: numberFormatScale
        });
      }

      return Number(num).toLocaleString();
    });

    _defineProperty(_assertThisInitialized(_this), "getActionItems", function () {
      var insights = _this.props.adDetails.insights[_this.props.platformType];
      var adType = _this.props.adDetails.campaign.objective;
      var items = [];

      if (insights.hasOwnProperty('cost_per_action_type') && insights.hasOwnProperty('actions')) {
        if (adType === 'LEAD_GENERATION') {
          var costObj = _.find(insights.cost_per_action_type, {
            action_type: 'leadgen.other'
          });

          var actionObj = _.find(insights.actions, {
            action_type: 'leadgen.other'
          });

          var costValue = costObj ? costObj.value : 0;
          items.push({
            text: pluralize('Lead', actionObj ? actionObj.value : 0),
            value: actionObj ? actionObj.value : 0
          });
          items.push({
            text: 'Per Lead',
            value: costValue ? _this.formatDollars(parseFloat(costValue)) : '$0'
          });
        } else if (adType === 'POST_ENGAGEMENT') {
          var _costObj = _.find(insights.cost_per_action_type, {
            action_type: 'post_engagement'
          });

          var _actionObj = _.find(insights.actions, {
            action_type: 'post_engagement'
          });

          var _costValue = _costObj ? _costObj.value : 0;

          items.push({
            text: pluralize('Engagement', _actionObj ? _actionObj.value : 0),
            value: _actionObj ? _actionObj.value : 0
          });
          items.push({
            text: 'Per Engagement',
            value: _costValue ? _this.formatDollars(parseFloat(_costValue)) : '$0'
          });
        } else if (adType === 'PAGE_LIKES') {
          var _costObj2 = _.find(insights.cost_per_action_type, {
            action_type: 'like'
          });

          var _actionObj2 = _.find(insights.actions, {
            action_type: 'like'
          });

          var _costValue2 = _costObj2 ? _costObj2.value : 0;

          items.push({
            text: pluralize('Page Like', _actionObj2 ? _actionObj2.value : 0),
            value: _actionObj2 ? _actionObj2.value : 0
          });
          items.push({
            text: 'Per Like',
            value: _costValue2 ? _this.formatDollars(parseFloat(_costValue2)) : '$0'
          });
        } else if (adType === 'LINK_CLICKS') {
          var _costObj3 = _.find(insights.cost_per_action_type, {
            action_type: 'link_click'
          });

          var _actionObj3 = _.find(insights.actions, {
            action_type: 'link_click'
          });

          var _costValue3 = _costObj3 ? _costObj3.value : null;

          items.push({
            text: pluralize('Link Click', _actionObj3 ? _actionObj3.value : 0),
            value: _actionObj3 ? _actionObj3.value : 0
          });
          items.push({
            text: 'Per Click',
            value: _costValue3 ? _this.formatDollars(parseFloat(_costValue3)) : '$0'
          });
        } else if (adType === 'VIDEO_VIEWS') {
          var _costObj4 = _.find(insights.cost_per_action_type, {
            action_type: 'video_view'
          });

          var _actionObj4 = _.find(insights.actions, {
            action_type: 'video_view'
          });

          var _costValue4 = _costObj4 ? _costObj4.value : 0;

          items.push({
            text: pluralize('View', _actionObj4 ? _actionObj4.value : 0),
            value: _actionObj4 ? _actionObj4.value : 0
          });
          items.push({
            text: 'Per View',
            value: _costValue4 ? _this.formatDollars(parseFloat(_costValue4)) : '$0'
          });
        }
      }

      return items;
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionalItems", function () {
      var insights = _this.props.adDetails.insights[_this.props.platformType];
      var items = [];

      _this.props.optionalFields.forEach(function (field) {
        if (_this.props.adDetails.campaign.objective.includes(field.toUpperCase())) {
          return;
        }

        var item = _.find(insights.actions, {
          action_type: field
        });

        if (item) {
          var keyName = _this.translateKeyToName(field, item.value);

          items.push({
            text: keyName,
            value: item.value
          });
        }
      });

      return items;
    });

    _defineProperty(_assertThisInitialized(_this), "getOtherItems", function () {
      var adDetails = _this.props.adDetails;
      var insights = adDetails.insights[_this.props.platformType];
      var convertedItems = [];

      _this.props.otherFields.forEach(function (item) {
        if (!insights.hasOwnProperty(item)) {
          return false;
        }

        var itemValue = typeof insights[item] === 'number' ? _this.formatDollars(insights[item]) : _this.formatNumber(parseInt(insights[item]));
        var itemName = ['reach', 'spend'].includes(item) ? item : _this.translateKeyToName(item, item.value);
        convertedItems.push({
          text: itemName,
          value: itemValue
        });
      });

      return convertedItems;
    });

    _defineProperty(_assertThisInitialized(_this), "extraActionItems", function () {
      var insights = _this.props.adDetails.insights[_this.props.platformType];
      var adType = _this.props.adDetails.campaign.objective;
      var items = [];

      if (insights.hasOwnProperty('cost_per_action_type') && insights.hasOwnProperty('actions')) {
        insights.actions.forEach(function (action) {
          if (['leadgen.other', 'post_engagement', 'post', 'like', 'link_click', 'video_view'].concat(_toConsumableArray(_this.props.otherFields), _toConsumableArray(_this.props.optionalFields)).includes(action.action_type)) {
            return;
          }

          var costObj = _.find(insights.cost_per_action_type, {
            action_type: action.action_type
          });

          var costValue = costObj ? costObj.value : 0;
          var typeDisplay = "".concat(action.action_type).replace(/_|\./g, ' ');

          if (typeDisplay.match(/^offsite conversion fb/)) {
            typeDisplay = typeDisplay.replace('offsite conversion fb', '');
          }

          typeDisplay = typeDisplay.replace(/[0-9]/g, '').trim();
          typeDisplay = pluralize.singular(typeDisplay);
          items.push({
            text: pluralize(typeDisplay, action.value),
            value: action.value
          });
          items.push({
            text: "Per ".concat(typeDisplay),
            value: costValue ? _this.formatDollars(parseFloat(costValue)) : '$0'
          });
        });
      }

      return items;
    });

    _defineProperty(_assertThisInitialized(_this), "formatDollars", function (val) {
      return "$".concat(val.toFixed(2));
    });

    _defineProperty(_assertThisInitialized(_this), "translateKeyToName", function (key, count) {
      return pluralize(_.startCase(key), count);
    });

    return _this;
  }

  _createClass(OverviewStats, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var actionItems = this.getActionItems();
      var otherItems = this.getOtherItems();
      var optionalItems = this.getOptionalItems();
      var extraActions = this.extraActionItems();
      var allItems = [].concat(_toConsumableArray(actionItems), _toConsumableArray(otherItems), _toConsumableArray(optionalItems), _toConsumableArray(extraActions));
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#292929',
          marginLeft: 10,
          paddingBottom: 16,
          fontSize: 20
        }
      }, this.props.platformType !== 'summary' ? "".concat(_.startCase(this.props.platformType), " Performance") : 'Summary'), /*#__PURE__*/React.createElement("div", {
        style: this.props.style
      }, allItems.map(function (item, index) {
        return /*#__PURE__*/React.createElement(StackedBigText, {
          key: "".concat(item.text, "_").concat(index),
          numberStyle: {
            color: _this2.props.theme.colors.secondaryColor
          },
          style: {
            borderBottom: 'none',
            flex: '0 0 33%'
          },
          number: item.value,
          text: item.text
        });
      })));
    }
  }]);

  return OverviewStats;
}(Component), _defineProperty(_class2, "defaultProps", {
  listStyle: {},
  style: {},
  otherFields: ['impressions', 'reach', 'spend'],
  optionalFields: ['post_reaction', 'post_engagement', 'page_engagement', 'link_click', 'like', 'comment', 'share'],
  platformType: 'facebook'
}), _temp)) || _class);
export default OverviewStats;